export default "__VITE_ASSET__RUEJJSTe__"